import React, { useState } from "react";
import { emailValidation } from "utils/validation";

const EmailField = ({ saveEmail, placeholder,defaultValue }) => {
  const [value, setValue] = useState(defaultValue || "");
  const [error, setError] = useState(false);

  const saveHandler = () => {
    if (!emailValidation(value)) return setError(true);
    setError(false);
    setValue("");
    console.log('value', value)
    saveEmail(value);
  };

  const changeHandler = (event) => {
    setError(false);
    setValue(event.target.value);
  };
  return (
    <input
      placeholder={placeholder || ""}
      className={`emails-field ${error ? "error" : ""}`}
      type="text"
      value={value}
      onChange={changeHandler}
      onKeyDown={(event) => {
        if (event.keyCode !== 13) return;
        saveHandler();
      }}
      onBlur={saveHandler}
    />
  );
};

export default EmailField;
